var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "time-tracking__list__entry row justify-between items-center gutter-md-x-md gutter-x-xs gutter-y-sm q-pa-md"
    },
    [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c("inline-edit-input", {
            attrs: {
              readonly: !_vm.userIsOwnerOfEntryOrAdmin,
              placeholder: _vm.$t("no_description"),
              value: _vm.timeEntry.description
            },
            on: {
              save: _vm.handleSaveDescription,
              click: _vm.checkUserHasSufficientPermissions
            }
          }),
          _vm.showUser
            ? _c(
                "div",
                { staticClass: "row items-center" },
                [
                  _c("q-icon", {
                    staticClass: "gt-xs",
                    attrs: { name: "person", color: "faded", size: "12px" }
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "q-caption text-faded q-ml-sm-sm q-ml-none"
                    },
                    [_vm._v(_vm._s(_vm.userName))]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm.timeEntry.billed
        ? _c(
            "div",
            { staticClass: "col-auto" },
            [
              _c(
                "q-chip",
                {
                  staticClass: "gt-md",
                  attrs: {
                    dense: "",
                    color: "positive",
                    "text-color": "white",
                    icon: "check"
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("billed")) + "\n    ")]
              ),
              _c(
                "q-icon",
                {
                  staticClass: "lt-lg",
                  attrs: { name: "check", color: "positive" }
                },
                [
                  _c("q-tooltip", { attrs: { delay: 300 } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("billed_tooltip")) +
                        "\n      "
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "col-5 col-lg-4 col-xl-3 row gt-sm" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("customer-indicator", {
              attrs: {
                clickable: "",
                customer: _vm.timeEntry.customer
                  ? _vm.timeEntry.customer.data
                  : undefined
              }
            }),
            _c("customer-popover", {
              attrs: {
                "active-customer": _vm.timeEntry.customer
                  ? _vm.timeEntry.customer.data
                  : undefined
              },
              on: { "select-customer": _vm.handleSelectCustomer }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("project-indicator", {
              attrs: {
                project: _vm.timeEntry.project
                  ? _vm.timeEntry.project.data
                  : undefined,
                clickable: ""
              }
            }),
            _c("project-popover", {
              attrs: {
                "active-project": _vm.timeEntry.project
                  ? _vm.timeEntry.project.data
                  : undefined
              },
              on: { "select-project": _vm.handleSelectProject }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          _c("q-checkbox", {
            attrs: {
              "keep-color": "",
              "checked-icon": "attach_money",
              "unchecked-icon": "money_off",
              color: _vm.timeEntry.billable ? "faded" : "light",
              disabled: !_vm.userIsOwnerOfEntryOrAdmin,
              value: _vm.timeEntry.billable
            },
            on: { input: _vm.handleToggleBillable }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          !_vm.isRunning
            ? _c("inline-edit-duration", {
                attrs: {
                  duration: _vm.timeEntry.duration,
                  "started-at": _vm.timeEntry.started_at.date,
                  "stopped-at": _vm.timeEntry.stopped_at.date,
                  disabled: !_vm.userIsOwnerOfEntryOrAdmin
                },
                on: {
                  save: _vm.handleSaveDuration,
                  click: _vm.checkUserHasSufficientPermissions
                }
              })
            : _c("span", { staticClass: "text-faded text-italic" }, [
                _vm._v(_vm._s(_vm.$t("running")))
              ])
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-auto" },
        [
          _c("q-btn", {
            attrs: {
              flat: "",
              dense: "",
              round: "",
              color: "light",
              icon: "play_arrow"
            },
            on: { click: _vm.handleResumeTimeEntry }
          }),
          _c("q-btn", {
            class: {
              disabled: !_vm.userIsOwnerOfEntryOrAdmin,
              "non-selectable": !_vm.userIsOwnerOfEntryOrAdmin
            },
            attrs: {
              flat: "",
              dense: "",
              round: "",
              color: "light",
              icon: "delete"
            },
            on: { click: _vm.handleDeleteTimeEntry }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-12 row lt-md" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("customer-indicator", {
              attrs: {
                clickable: "",
                customer: _vm.timeEntry.customer
                  ? _vm.timeEntry.customer.data
                  : undefined
              }
            }),
            _c("customer-popover", {
              attrs: {
                "active-customer": _vm.timeEntry.customer
                  ? _vm.timeEntry.customer.data
                  : undefined
              },
              on: { "select-customer": _vm.handleSelectCustomer }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col" },
          [
            _c("project-indicator", {
              attrs: {
                project: _vm.timeEntry.project
                  ? _vm.timeEntry.project.data
                  : undefined,
                clickable: ""
              }
            }),
            _c("project-popover", {
              attrs: {
                "active-project": _vm.timeEntry.project
                  ? _vm.timeEntry.project.data
                  : undefined
              },
              on: { "select-project": _vm.handleSelectProject }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }